import { Button, Alert, Snackbar, Typography } from '@goshippo/components';
import { useCallback, useMemo, useState } from 'react';
import { SnackbarActionAlertType } from './types';
import NoticeAlert from '@goshippo/libraries/shared/NoticeAlert';

const SnackbarAlert = ({
  onClose,
  message,
  severity,
  autoHideDuration,
  actionFunction,
  actionMessage,
  anchorOrigin,
}: SnackbarActionAlertType) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleActionClick = useCallback(() => {
    setIsOpen(false);
    if (actionFunction) {
      actionFunction();
    }
    onClose();
  }, [actionFunction, onClose]);

  const handleToClose = useCallback(
    (_: unknown, reason?: 'timeout' | 'clickaway' | 'escapeKeyDown') => {
      if (reason === 'clickaway') return;
      setIsOpen(false);
      onClose();
    },
    [onClose],
  );

  const alertAction = useMemo(() => {
    if (!actionMessage) return null;
    return (
      <Button
        variant="text"
        size="small"
        color="secondary"
        aria-label="snackbar-action-button"
        onClick={handleActionClick}
        dataTestId="snackbar-action-button"
      >
        {actionMessage}
      </Button>
    );
  }, [actionMessage, handleActionClick]);
  return (
    <Snackbar
      open={isOpen}
      onClose={handleToClose}
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
    >
      <div>
        {/* SnackbarAlert with severity "notice" is a custom Alert type that share the same UI layout with custom color themes,
            NoticeAlert component is exported from shared libraries */}
        {severity === 'notice' ? (
          <NoticeAlert onClose={onClose}>
            <Typography variant="body" component="p">
              {message}
            </Typography>
            {alertAction}
          </NoticeAlert>
        ) : (
          <Alert severity={severity} onClose={onClose}>
            <Typography variant="body" component="p">
              {message}
            </Typography>
            {alertAction}
          </Alert>
        )}
      </div>
    </Snackbar>
  );
};

export default SnackbarAlert;
